import questionReader from '../../store/readHelpers/QuestionReader';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import hardwareDetectionService from '../../services/HardwareDetectionService';
import uiReader from '../../store/readHelpers/uiReader';

const modalsContainerSelector = {
    selectShouldRenderOneWayNavigationModals(questionId) {
        const question = assessmentReader.getQuestion(questionId);
        return questionReader.shouldCommitAnswerTimestamp(question);
    },

    selectShouldRenderSecondScreenDetectedModal() {
        return hardwareDetectionService.isAdditionalScreenDetectionRequired() && uiReader.wasScreenExtended();
    },

    selectShouldRenderTalviewInitAllocatedTimePassedModal() {
        return uiReader.isTalviewInitAllocatedTimePassedMessageDisplayed();
    },

    lastOverlays: null,
    lastOverlayIds: [],

    // Memoized on the pciResourceOverlays object reference so the returned array keeps
    // the same identity across unrelated state updates, avoiding needless re-renders of
    // ModalsContainer (react-redux connect does a shallow prop comparison).
    selectPciResourceOverlayIds(overlays) {
        if (overlays === this.lastOverlays) {
            return this.lastOverlayIds;
        }
        this.lastOverlays = overlays;
        this.lastOverlayIds = Object.keys(overlays || {}).map(Number);
        return this.lastOverlayIds;
    },

    selectProps(state) {
        const { currentlyShown } = state;

        return {
            shouldRenderOneWayNavigationModals: this.selectShouldRenderOneWayNavigationModals(currentlyShown.questionId),
            shouldRenderSecondScreenDetectedModal: this.selectShouldRenderSecondScreenDetectedModal(),
            shouldRenderTalviewInitAllocatedTimePassedModal: this.selectShouldRenderTalviewInitAllocatedTimePassedModal(),
            pciResourceOverlayIds: this.selectPciResourceOverlayIds(state.ui?.pciResourceOverlays),
        };
    },
};

export default modalsContainerSelector;
